// ProVet has no status codes of its own -- the backend derives this from ProVet's own
// active/no_show fields (see AppointmentStatusResolver) into AppointmentDto.Status. Values are
// pinned to the backend's VetCore.BackEnd.Shared.Constants.AppointmentStatus and must stay in sync
// with it.
//
// `1` is RETIRED and must never be reused: it was `Confirmada`, from the confirmation flow that was
// removed as a product concept. A stored/legacy `1` no longer matches any member, so the mappers'
// `value in AppointmentStatus` guard degrades it to `Programada` instead of resurrecting it.
export enum AppointmentStatus {
  Programada = 0,
  Cancelada = 2,
  Completada = 3,
  NoPresentado = 4,
}
